function base64ToBlob(base64: string, mimeType: string): Blob {
  const base64Data = base64.split(',')[1] || base64;
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mimeType });
}

export function dataUrlToBlob(dataUrl: string): Blob {
  const mimeMatch = dataUrl.match(/data:([^;]+);base64,/);
  const mimeType = mimeMatch ? mimeMatch[1] : 'application/octet-stream';
  return base64ToBlob(dataUrl, mimeType);
}
